/**
 * Google Analytics 4 (gtag.js) adapter — loaded dynamically/async so it
 * never blocks app rendering or degrades performance. Automatic
 * Enhanced Measurement pageviews are disabled (`send_page_view: false`)
 * because SPA pageviews are sent manually from `usePageTracking` — this
 * is the single source of truth for pageviews and is what prevents
 * duplicate tracking (see `index.js`'s `lastPageKey` guard too).
 */
let gaInitialized = false;
let gaScriptPromise = null;

function loadGaScript(measurementId) {
  if (gaScriptPromise) return gaScriptPromise;

  gaScriptPromise = new Promise((resolve) => {
    const existing = document.querySelector(`script[data-ga4="${measurementId}"]`);
    if (existing) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.async = true;
    script.dataset.ga4 = measurementId;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    script.onload = () => resolve();
    script.onerror = () => resolve(); // never let a network hiccup break the app
    document.head.appendChild(script);
  });

  return gaScriptPromise;
}

export function initGa4(measurementId) {
  if (!measurementId || gaInitialized) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });

  gaInitialized = true;
  loadGaScript(measurementId);
}

export function sendGa4PageView(pathname) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: `${window.location.origin}${pathname}`,
    page_path: pathname,
  });
}

export function sendGa4Event(name, params = {}) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
